import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useTheme,
  TableContainer,
  TableCell,
  Paper,
  Typography,
} from '@mui/material';

function createData(
  score: string,
  clinical: string,
  monitoring: string,
  response: string
) {
  return { score, clinical, monitoring, response };
}

const rows = [
  createData(
    '0~4',
    'Low',
    'Minimum every 12 hrs if score of 0\nMinimum every 4-6 hrs if score 1-4',
    'Assessment by a competent registered nurse or equivalent,\nto decide change in frequency of clinical monitoring or escalation of care'
  ),
  createData(
    'Score of 3 in any individual parameter',
    'Low-medium',
    'Minimum every hr',
    'Urgent review by a ward-based doctor,\nto decide change in frequency of clinical monitoring or escalation of care'
  ),
  createData(
    '5~6',
    'Medium',
    'Minimum every hr',
    'Urgent review by a ward-based doctor or acute team nurse,\nto decide if critical care team assessment is needed'
  ),
  createData(
    '≥ 7',
    'High',
    'Continuous monitoring of vital signs',
    'Emergent assessment by a clinical team or critical care team\nand usually transfer to higher level of care'
  ),
];

const ScoreBox = () => {
  const { palette } = useTheme();

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: '93%',
        margin: '30px auto 0 auto',
        border: '1px solid lightgray',
        borderRadius: '10px',
      }}
    >
      <Table
        sx={{
          minWidth: 650,
        }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  color: `${palette.primary.main}`,
                }}
              >
                Score
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  color: `${palette.primary.main}`,
                }}
              >
                Clinical risk
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  color: `${palette.primary.main}`,
                }}
              >
                Frequency of monitoring
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  color: `${palette.primary.main}`,
                }}
              >
                Response
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow
              key={row.score}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {row.score}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {row.clinical}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {row.monitoring}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {row.response}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ScoreBox;
